import React from "react";
import { motion } from "framer-motion";
import "../components/LatestCollection.css";
import img1 from "../assets/woman-jacket.webp";
import img2 from "../assets/woman-hoodie.webp";
import img3 from "../assets/woman-tshirtm.webp";
import img4 from "../assets/woman-shirt.webp";
import img5 from "../assets/woman-shorts.webp";
import img6 from "../assets/woman-jeans.webp";

const collections = [
  {
    id: 1,
    title: "Women Jacket",
    image:img1,
  },
  {
    id: 2,
    title: "Women Sweat Top & Hoodies",
    image: img2,
  },
  {
    id: 5,
    title: "Women Shorts & Lower",
    image:img5,
  },
  {
    id: 3,
    title: "Women T-Shirts",
    image: img3,
  },
  {
    id: 4,
    title: "Women Shirts",
    image: img4,
  },
 
  {
    id: 6,
    title: "Women Jeans & Pant",
    image:img6,
  },
];

export default function WomenCollection() {
  return (
    <section className="latest-collection">
      <div className="collection-header">
        <h2>Women Product Showcase</h2>
      </div>

      <div className="collection-grid">
        {collections.map((item, index) => (
          <motion.div
            key={item.id}
            className="collection-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
            whileHover={{ scale: 1.05 }}
          >
            <img src={item.image} alt={item.title} />
            <h4>{item.title}</h4>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
